import styles from './ErrorOverlay.module.css'

interface Props {
  message: string | null
  onRetry: () => void
}

export function ErrorOverlay({ message, onRetry }: Props) {
  if (!message) return null
  return (
    <div className={styles.wrap}>
      <p>{message}</p>
      <button type="button" onClick={onRetry}>
        Retry
      </button>
    </div>
  )
}
